import { ProfileProjectDetailInfo } from '~/api/repository'
import { ProjectDetailModel } from '~/types/model/project-detail.model'

export class ProfileProjectDetailModel extends ProjectDetailModel {
  constructor (res: ProfileProjectDetailInfo) {
    super(res)
  }

  get infoList () {
    return [
      // {
      //   icon: 'generating_tokens',
      //   label: 'Launching Days',
      //   type: 'text',
      //   contents: [ {
      //     label: this.about.launchingDate
      //   } ]
      // },
      {
        icon: 'category',
        label: 'Category',
        type: 'chip',
        contents: this.about.categoryList.map(category => {
          return {
            label: category,
            value: category
          }
        })
      },
      {
        icon: 'web',
        label: 'Website',
        type: this.about.officialLink ? 'link' : 'text',
        contents: this.about.officialLink ? [ {
          label: this.about.officialLink,
          value: this.about.officialLink
        } ] : ''
      },
      {
        icon: 'group',
        label: 'Community',
        type: 'link',
        contents: this.about.communityLink.map(community => {
          return {
            label: community.name,
            value: community.link,
          }
        })
      },
      {
        icon: 'more_horiz',
        label: 'Other',
        type: 'link',
        contents: this.about.otherLink.map(other => {
          return {
            label: other.name,
            value: other.link
          }
        })
      },
    ]
  }
}